<template>
    <defaultSec :title="'企微标签列表'" class="qw-tag-list-wrap">
        <el-form :inline="true" class="demo-form-inline select-wrap" size="mini">
            <el-form-item label="标签名称">
                <el-input
                    v-model="formParam.tagName"
                    clearable
                    placeholder="输入标签名称查询"
                    @keyup.enter.native="searchList">
                </el-input>
            </el-form-item>
            <el-form-item>
                <el-button-group>
                    <el-button type="primary" size="mini" @click="searchList">查询</el-button>
                    <el-button type="success" size="mini" :loading="syncLoading" @click="syncTagList">
                        同步企微标签
                    </el-button>
                </el-button-group>
            </el-form-item>
        </el-form>

        <tablePagination
            :total="total"
            :pageSize="formParam.pageSize"
            :currentPage="formParam.currentPage"
            @handlePage="handlePage">
            <el-table v-loading="loading" :data="tableList" border size="mini" :height="tableHeight">
                <el-table-column type="index" label="序号" width="55"></el-table-column>
                <el-table-column prop="tagGroupName" label="标签组" min-width="140"></el-table-column>
                <el-table-column prop="name" label="标签名称" min-width="140"></el-table-column>
                <el-table-column prop="wxContactTagId" label="企微标签ID" min-width="190"></el-table-column>
                <el-table-column prop="statusName" label="状态" width="80">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status === 1" size="mini" type="success">有效</el-tag>
                        <el-tag v-else size="mini" type="info">{{scope.row.statusName || '无效'}}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="tagTypeName" label="标签类型" width="110"></el-table-column>
                <el-table-column prop="conditionTypeName" label="规则类型" width="110"></el-table-column>
                <el-table-column prop="userNum" label="用户数" width="90"></el-table-column>
                <el-table-column prop="sort" label="排序" width="80"></el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="160"></el-table-column>
                <el-table-column prop="updateTime" label="更新时间" width="160"></el-table-column>
            </el-table>
        </tablePagination>
    </defaultSec>
</template>

<script>
    import defaultSec from '@c/defaultSection'
    import tablePagination from '@c/tablePagination'

    export default {
        data() {
            return {
                loading: false,
                syncLoading: false,
                tableHeight: 500,
                total: 0,
                tableList: [],
                formParam: {
                    currentPage: parseInt(this.$route.query.currentPage) || 1,
                    pageSize: 20,
                    tagName: ''
                }
            }
        },
        components: {
            defaultSec,
            tablePagination
        },
        mounted() {
            this.initList()
            this.setTableHeight()
            window.addEventListener('resize', this.setTableHeight)
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.setTableHeight)
        },
        methods: {
            initList() {
                this.loading = true
                this.$apiGet('lechun-cms/tag/getTagList', this.formParam).then(res => {
                    this.total = res.total || 0
                    this.tableList = res.list || []
                    this.loading = false
                    this.setTableHeight()
                }).catch(() => {
                    this.loading = false
                })
            },
            searchList() {
                this.formParam.currentPage = 1
                this.pushListRoute(1)
                this.initList()
            },
            handlePage(page) {
                this.formParam.currentPage = page
                this.pushListRoute(page)
                this.initList()
            },
            syncTagList() {
                this.$confirm('确定从企业微信同步标签吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.syncLoading = true
                    this.$apiGet('lechun-cms/tag/pullTag', {}).then(res => {
                        this.syncLoading = false
                        this.$message({
                            type: 'success',
                            message: res || '同步成功'
                        })
                        this.formParam.currentPage = 1
                        this.pushListRoute(1)
                        this.initList()
                    }).catch(() => {
                        this.syncLoading = false
                    })
                }).catch(() => {})
            },
            pushListRoute(page) {
                this.$router.push({path: '/qwTagList', query: {currentPage: page}}).catch(() => {})
            },
            setTableHeight() {
                this.$nextTick(() => {
                    const body = document.querySelector('.default-body')
                    this.tableHeight = body ? body.offsetHeight - 114 : 500
                })
            }
        }
    }
</script>

<style scoped lang="scss" rel="stylesheet/scss">
    .qw-tag-list-wrap {
        .el-input {
            width: 220px;
        }
    }
</style>
